(function() {

  function setCookie(name, value) {
    const d = new Date();
    d.setTime(d.getTime() + (90 * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  const fbclid = urlParams.get('fbclid');

  // Capture parameters on first landing page visit
  if (utmSource || fbclid || !getCookie('vbo_initial_utm_source')) {
    const nowISO = new Date().toISOString();
    
    if (utmSource) setCookie('vbo_initial_utm_source', utmSource);
    if (urlParams.get('utm_campaign')) setCookie('vbo_utm_campaign', urlParams.get('utm_campaign'));
    if (urlParams.get('utm_term') || urlParams.get('ad_id')) setCookie('vbo_utm_term', urlParams.get('utm_term') || urlParams.get('ad_id'));
    if (urlParams.get('utm_content') || urlParams.get('adset_id')) setCookie('vbo_utm_content', urlParams.get('utm_content') || urlParams.get('adset_id'));
    if (urlParams.get('utm_source_platform') || urlParams.get('utm_placement')) {
      setCookie('vbo_utm_source_platform', urlParams.get('utm_source_platform') || urlParams.get('utm_placement'));
    }
    setCookie('vbo_initial_landing_page', window.location.pathname);
    setCookie('vbo_initial_landing_url', window.location.href);
    setCookie('vbo_initial_set_at', nowISO);
    setCookie('vbo_initial_fbclid_present', fbclid ? 'true' : 'false');
  }

  // Sync cookies to Shopify Cart Attributes so Customer Events can access them
  async function syncAttributesToCart() {
    const attributes = {
      'vbo_initial_utm_source': getCookie('vbo_initial_utm_source') || '',
      'vbo_utm_term': getCookie('vbo_utm_term') || '',
      'vbo_utm_campaign': getCookie('vbo_utm_campaign') || '',
      'vbo_utm_content': getCookie('vbo_utm_content') || '',
      'vbo_utm_source_platform': getCookie('vbo_utm_source_platform') || '',
      'vbo_initial_landing_page': getCookie('vbo_initial_landing_page') || '',
      'vbo_initial_landing_url': getCookie('vbo_initial_landing_url') || '',
      'vbo_initial_set_at': getCookie('vbo_initial_set_at') || '',
      'vbo_initial_fbclid_present': getCookie('vbo_initial_fbclid_present') || ''
    };

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      });
    } catch (e) {
      console.error('[VBO] Failed to update cart attributes:', e);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    syncAttributesToCart();
  } else {
    document.addEventListener('DOMContentLoaded', syncAttributesToCart);
  }
})();